export default __webpack_public_path__ + "static/media/L_sound.824b1f81.mp3";